import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { TaskService } from "@/_services/task.service";
import { CombinedTasksService } from "@/_services/combined-task.service";
import { TaskPanelComponent } from "@/components/shared/task-panel/task-panel.component";
import { Task } from "@/_models/task.interface";
import { map, switchMap, tap } from "rxjs/operators";
import { of } from "rxjs";

@Component({
    selector: "app-home-task-detail",
    standalone: true,
    imports: [CommonModule, TaskPanelComponent],
    templateUrl: "./home-task-detail.component.html",
    styleUrls: ["./home-task-detail.component.scss"],
})
export class HomeTaskDetailComponent implements OnInit {
    taskPanelVisible: boolean = false;
    selectedTask: Task | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private taskService: TaskService,
        private combinedTasksService: CombinedTasksService,
    ) {}

    ngOnInit() {
        this.route.params
            .pipe(
                map((params) => params.taskId),
                switchMap((taskId) => {
                    if (taskId === "new") {
                        this.selectedTask = null;
                        this.taskPanelVisible = true;
                        return of(null);
                    } else {
                        return this.taskService.getTask(taskId);
                    }
                }),
                tap((task) => {
                    if (task) {
                        this.selectedTask = task;
                        this.taskPanelVisible = true;
                    }
                }),
            )
            .subscribe({
                error: () => {
                    this.router.navigate(["/home/tasks"]);
                },
            });
    }

    onTaskPanelHide() {
        this.router.navigate(["/home/tasks"]);
    }

    onTaskSaved(): void {
        this.combinedTasksService.requestReload();
    }
}
